import React from "react";
import PageActions from "../../../base/PageActions";
import ContentBox from "../../../../components/content-box/ContentBox";
import _image_service from "../../../../services/ImageService";
import '../../../styles/Common.scss';
import './CreditsPage.scss';

const CreditsPage = () => {

    const page: PageActions = new PageActions({
        title: `Credits - Chase the Fox`,
        description: "Credits and contact information for Chase and the site team!",
        keywords: ["credits", "chase the fox team", "contact", "contact info", "contact information", "email", "social links"],
        imgSrc: `chase/assets/chase_full.png`,
        url: `credits`
    });

    return page.generateMetaContent(
        <ContentBox className="contact-content" header="Credits">
            <div className="credits-bounds">
                <div className="credit-box">
                    <h4 className="center">Chase</h4>
                    <p className="center">Website designer, developer, and artist</p>
                    <table className="contact-table">
                        <tbody>
                        <tr>
                            <td>
                                <img className="contact-image"
                                     src={_image_service.getCdnImageSrc(`common/media/email_icon.png`)}
                                     alt="Email"/>
                            </td>
                            <td>chasereynard [[at]] gmail.com</td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://bsky.app/profile/chasetheredfox.bsky.social" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/bluesky_logo.png`)}
                                        alt="Bluesky"/>
                                </a>
                            </td>
                            <td><a href="https://bsky.app/profile/chasetheredfox.bsky.social"
                                   target="_blank"
                                   rel="noopener noreferrer">chasetheredfox</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://www.furaffinity.net/user/chasereynard" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/fa_logo.png`)}
                                        alt="FurAffinity"/>
                                </a>
                            </td>
                            <td><a href="https://www.furaffinity.net/user/chasereynard"
                                   target="_blank"
                                   rel="noopener noreferrer">ChaseReynard</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://deviantart.com/ChaseReynard" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/da_logo.png`)}
                                        alt="DeviantArt"/>
                                </a>
                            </td>
                            <td><a href="https://deviantart.com/ChaseReynard"
                                   target="_blank"
                                   rel="noopener noreferrer">ChaseReynard</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="contact-right">
                        <img
                            className="character-pic"
                            src={_image_service.getCdnImageSrc(`chase/assets/chase_full.png`)}
                            alt="Chase the Fox"/>
                    </div>
                </div>
                <div className="credit-box">
                    <h4 className="center">Marcus</h4>
                    <p className="center">Website developer, Tale Chasers editor</p>
                    <table className="contact-table">
                        <tbody>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="contact-right">
                        <img
                            className="character-pic"
                            src={_image_service.getCdnImageSrc(`chase/credits/marcus_full.png`)}
                            alt="Marcus the Cataroo"/>
                    </div>
                </div>
                <div className="credit-box">
                    <h4 className="center">StuffAlso</h4>
                    <p className="center">Tale Chasers editor</p>
                    <table className="contact-table">
                        <tbody>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="contact-right">
                        <img
                            className="character-pic"
                            src={_image_service.getCdnImageSrc(`chase/credits/stuff_full.png`)}
                            alt="Oliver the Shiba Inu"/>
                    </div>
                </div>
                <div className="credit-box">
                    <h4 className="center">Techno</h4>
                    <p className="center">Website developer and designer</p>
                    <table className="contact-table">
                        <tbody>
                        <tr>
                            <td>
                                <a href="https://bsky.app/profile/technotanuki.bsky.social" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/bluesky_logo.png`)}
                                        alt="Bluesky"/>
                                </a>
                            </td>
                            <td><a href="https://bsky.app/profile/technotanuki.bsky.social"
                                   target="_blank"
                                   rel="noopener noreferrer">technotanuki</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://www.instagram.com/technotanuki/" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/ig_logo.png`)}
                                        alt="Instagram"/>
                                </a>
                            </td>
                            <td><a href="https://www.instagram.com/technotanuki/"
                                   target="_blank"
                                   rel="noopener noreferrer">technotanuki</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://linktr.ee/techno_tanuki" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/linktree_logo.png`)}
                                        alt="LinkTree"/>
                                </a>
                            </td>
                            <td><a href="https://linktr.ee/techno_tanuki"
                                   target="_blank"
                                   rel="noopener noreferrer">techno_tanuki</a>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="contact-right">
                        <img
                            className="character-pic"
                            src={_image_service.getCdnImageSrc(`chase/credits/techno_full.png`)}
                            alt="Techno the Tanuki"/>
                    </div>
                </div>
            </div>
        </ContentBox>
    );
}

export default CreditsPage;